import React from 'react'
import { getColor, isHidden } from '../utils'
import { FIELD_TYPES } from '../../../../utility/constants'
import TableCellList from './TableCellList'
import TableCellFile from './TableCellFile'
import TableCellDate from './TableCellDate'
import TableCellCurrency from './TableCellCurrency'
import TableCellText from './TableCellText'
import { isFieldHidden } from '../../../../pages/DataEntryPage/utils/fieldUtil'

const RenderTableCells = ({
  subField,
  reviewData,
  hiddenColumns,
  value,
  previewCurrency,
  conditionallyEnableDisable,
  allPreviewValue,
}) => {
  if (subField.data_structure === FIELD_TYPES.LIST) {
    return (
      <TableCellList
        color={getColor(reviewData, subField)}
        isHidden={
          isHidden(hiddenColumns, subField) ||
          isFieldHidden({ id: parseInt(subField.id), is_hidden: subField.is_hidden }, [], [], {
            allValues: allPreviewValue,
            conditionalEnableDisable: conditionallyEnableDisable,
          })
        }
        value={value}
        width={subField.subfield_column_width_in_rem ? subField.subfield_column_width_in_rem : 7}
      />
    )
  } else if (subField.data_structure === FIELD_TYPES.FILE) {
    return (
      <TableCellFile
        color={getColor(reviewData, subField)}
        isHidden={
          isHidden(hiddenColumns, subField) ||
          isFieldHidden({ id: parseInt(subField.id), is_hidden: subField.is_hidden }, [], [], {
            allValues: allPreviewValue,
            conditionalEnableDisable: conditionallyEnableDisable,
          })
        }
        value={value}
        width={subField.subfield_column_width_in_rem ? subField.subfield_column_width_in_rem : 7}
      />
    )
  } else if (
    subField.data_structure === FIELD_TYPES.DATE ||
    subField.data_structure === FIELD_TYPES.DATETIME
  ) {
    return (
      <TableCellDate
        isHidden={
          isHidden(hiddenColumns, subField) ||
          isFieldHidden({ id: parseInt(subField.id), is_hidden: subField.is_hidden }, [], [], {
            allValues: allPreviewValue,
            conditionalEnableDisable: conditionallyEnableDisable,
          })
        }
        color={getColor(reviewData, subField)}
        value={value}
        type={subField.data_structure}
        width={subField.subfield_column_width_in_rem ? subField.subfield_column_width_in_rem : 7}
      />
    )
  } else if (subField.data_structure === FIELD_TYPES.CURRENCY) {
    return (
      <TableCellCurrency
        isHidden={
          isHidden(hiddenColumns, subField) ||
          isFieldHidden({ id: parseInt(subField.id), is_hidden: subField.is_hidden }, [], [], {
            allValues: allPreviewValue,
            conditionalEnableDisable: conditionallyEnableDisable,
          })
        }
        color={getColor(reviewData, subField)}
        value={value}
        previewCurrency={previewCurrency}
        field={subField}
        width={subField.subfield_column_width_in_rem ? subField.subfield_column_width_in_rem : 7}
      />
    )
  } else {
    return (
      <TableCellText
        isHidden={
          isHidden(hiddenColumns, subField) ||
          isFieldHidden({ id: parseInt(subField.id), is_hidden: subField.is_hidden }, [], [], {
            allValues: allPreviewValue,
            conditionalEnableDisable: conditionallyEnableDisable,
          })
        }
        color={getColor(reviewData, subField)}
        value={value}
        width={subField.subfield_column_width_in_rem ? subField.subfield_column_width_in_rem : 7}
      />
    )
  }
}

export default RenderTableCells
